import {ChangeDetectionStrategy, Component, computed, HostBinding, Input, input} from "@angular/core";
import {GruppeMedlemListeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AvatarKomponent} from "web-ng2/delt/komponenter/avatar/avatar";
import {TranslateModule} from "@ngx-translate/core";
import {primærMedlemsrolle} from "felles-ng2/modell/medlemModellHjelpere";

const debug = initDebugger('Komponent');

/**
 * Visning av medlem for bruk i listing av medlemmer i kompakt form, feks i nedtrekkslister.
 */
@Component({
    selector: 'medlem-listevisning-kompakt',
    templateUrl: 'medlem-listevisning-kompakt.html',
    styleUrl: 'medlem-listevisning-kompakt.scss',
    host: {'data-testid': 'medlem'},
    imports: [
        AvatarKomponent,
        TranslateModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemListevisningKompaktKomponent {

    medlem = input.required<GruppeMedlemListeModell>();

    aktivRolleTittel = computed(() => primærMedlemsrolle(this.medlem())?.tittel ?? '')

    constructor() {
    }
}
